<template>
  <div :class="{ active: opened.length > 0 }" class="side-box">
    <span class="side-box__overlay" />
    <!-- kvůli zanořeným modalům pro transformační funkce potřebuju z-index 0 vždy -->
    <div
      v-if="endpoint != undefined"
      :class="{
        opened: opened.indexOf('editEndpoint') >= 0,
        'last-active': opened.indexOf('editEndpoint') === opened.length - 1
      }"
      class="side-box__inner"
      style="z-index: 0"
    >
      <div class="side-box__header d-flex justify-content-between align-items-center">
        <div class="atom-back atom-back--gray" @click="toggleEndpointConfirmation()">
          <div class="atom-back__inner d-flex align-items-center">
            <img src="@/assets/icons/arrows/arr-gray-left.svg" />
            <span>{{ $t("zpet") }}</span>
          </div>
        </div>
        <button :class="{ disabled: !isSubtopicValid }" class="btn btn-primary" @click="runEdit()">
          <div class="atom-icon">
            <img src="@/assets/icons/actions/ico-btn-ulozit.svg" />
          </div>
          {{ $t("ulozitEndpoint") }}
        </button>
      </div>
      <div class="side-box__title">
        <h2 v-if="originalEndpoint">
          {{ originalEndpoint.custDestName }}
        </h2>
      </div>
      <div class="side-box__content">
        <div v-if="errors.endpoint" class="text-danger">
          {{ errors.endpoint }}
        </div>
        <div v-if="protocol === 'HTTP'">
          <div class="side-box__row d-flex align-items-center mt-3">
            <span class="side-box__content__label">{{ $t("nazevEndpointu") }}</span>
            <div
              :class="{ 'has-error': errors.endpoint && !endpoint.custDestName }"
              class="side-box__content__input custom-control__custom-input ml-3"
            >
              <span v-if="!endpoint.custDestName" class="placeholder">{{ $t("zadejteNazevEndpointu") }}</span>
              <input
                v-model="endpoint.custDestName"
                autofocus
                class="w-100"
                maxlength="60"
                placeholder=""
                type="text"
                @click="changedEvent"
              />
            </div>
          </div>
          <FormInput
            :label="$t('volitelnyPopisEndpointu')"
            :value="endpoint.custDestDescription ?? ''"
            side-box
            @click="changedEvent"
            @input="endpoint.custDestDescription = $event"
          />
          <div v-if="endpoint.custDestParameters" class="side-box__row d-flex align-items-center mt-3">
            <span class="side-box__content__label">{{ $t("url") }}</span>
            <div
              :class="{
                'has-error': errors.endpoint && !endpoint.custDestParameters.url
              }"
              class="side-box__content__input custom-control__custom-input ml-3"
            >
              <span v-if="!endpoint.custDestParameters.url" class="placeholder">{{ $t("https://") }}</span>
              <input
                v-model="endpoint.custDestParameters.url"
                autofocus
                class="w-100"
                maxlength="1000"
                placeholder=""
                type="text"
                @click="changedEvent"
              />
            </div>
          </div>
          <div v-if="endpoint.custDestParameters" class="side-box__row d-flex align-items-center mt-3">
            <span class="side-box__content__label">{{ $t("autorizacniKlic") }}</span>
            <div class="side-box__content__input custom-control__custom-input ml-3">
              <span v-if="!endpoint.custDestParameters.auth" class="placeholder" />
              <input
                v-model="endpoint.custDestParameters.auth"
                autofocus
                class="w-100"
                maxlength="1000"
                placeholder=""
                type="text"
                value=""
                @click="changedEvent"
              />
            </div>
          </div>
          <EndpointHeadersField
            v-if="endpoint.custDestParameters"
            :headers="endpoint.custDestParameters.headers || {}"
            @update="endpoint.custDestParameters.headers = $event"
            @changed="changedEvent"
          />
          <div class="side-box__content">
            <TransformFunctionField
              :initial-transform-id="endpoint.transformationId"
              :opened-boxes="opened"
              sub-type="HTTP"
              type="OUT"
              @change="handleTransformChanged"
              @close-box="closeBox"
              @open-box="openBox"
            />
          </div>
          <div class="side-box__row mt-4 pb-4 d-flex align-items-center">
            <span class="side-box__content__label mt-sm-5" />
            <div
              class="w-100 side-box__content__input d-flex align-items-center pointer"
              @click="endpoint.custDestEnabled = !endpoint.custDestEnabled"
            >
              <div
                :class="{ checked: endpoint.custDestEnabled }"
                class="ml-sm-3 custom-control custom-control--checkbox"
                @click="changedEvent"
              >
                <input class="custom-control-input" type="checkbox" />
              </div>
              {{ $t("chciEndpointZapnout") }}
            </div>
          </div>
        </div>

        <div v-else-if="protocol === 'MQTT'">
          <NewEndpointFormFields
            ref="neFormFields"
            :endpoint="endpoint"
            :errors="errors"
            :fixed-protocol="protocol"
            :opened="opened"
            @close-box="closeBox"
            @open-box="openBox"
            @something-clicked="changedEvent"
            @subtopic-valid="isSubtopicValid = $event"
          />
        </div>
        <div v-if="showDataFlows" class="d-flex side-box__row align-items-start">
          <span class="side-box__content__label mt-sm-5 pt-4">{{ $t("pripojenKeSkupinam") }}</span>
          <div class="w-100 side-box__content__input border-top ml-3 pt-4">
            <div class="text-right ml-3">
              <a @click="openBox('newGroup')">{{ $t("vytvoritNovouSkupinu") }}</a>
            </div>
            <div class="side-box__content__groups mb-1">
              <div
                v-for="appended in actualGroups"
                :key="appended.deviceGroupId"
                class="d-flex side-box__content__group justify-content-between mb-2"
              >
                <span
                  class="mr-1 link-gray font-weight-normal"
                ><span>{{ appended.deviceGroupName }}</span></span>
                <div v-tooltip :title="$t('DISCONNECT_DF')" class="pointer" @click="unappendGroup(appended)">
                  <img
                    src="@/assets/icons/actions/ico-unlink.svg"
                    style="width: 20px"
                  />
                </div>
              </div>
              <div
                v-for="selectedG in selectedGroups"
                :key="selectedG.deviceGroupId"
                class="d-flex side-box__content__group justify-content-between mb-2"
              >
                <span
                  class="mr-1 link-gray font-weight-normal"
                ><span>{{ selectedG.deviceGroupName }}</span></span>
                <div v-tooltip :title="$t('DISCONNECT_DF')" class="pointer" @click="addRemoveGroup(selectedG)">
                  <img
                    src="@/assets/icons/actions/ico-unlink.svg"
                    style="width: 20px"
                    @click="changedEvent"
                  />
                </div>
              </div>
            </div>
            <div v-if="selectedGroups && actualGroups">
              <div
                v-if="
                  (selectedGroups.length + actualGroups.length < loadedGroups.length && selectGroupVisible == true) ||
                  selectedGroups.length + actualGroups.length == 0
                "
                class="side-box__content__input custom-control__select"
                @click="changedEvent"
              >
                <div
                  :class="{ opened: groupsOpened }"
                  class="side-box__content__input custom-control__select__selected"
                  @click="groupsOpened = !groupsOpened"
                >
                  <span class="gray-text">{{ $t("vyberteSkupinuZeSeznamu") }}</span>
                </div>
                <div :class="{ opened: groupsOpened }" class="custom-control__select__options">
                  <div
                    v-for="group in loadedGroups"
                    :key="group.deviceGroupId"
                    @click="
                      () => {
                        addRemoveGroup(group)
                        selectGroupVisible = false
                      }
                    "
                  >
                    <div
                      v-if="
                        !(
                          selectedGroups.filter((e) => e.deviceGroupId === group.deviceGroupId).length > 0 ||
                          actualGroups.filter((g) => g.deviceGroupId === group.deviceGroupId).length > 0
                        )
                      "
                      class="custom-control__select__option d-flex align-items-center"
                    >
                      <div v-if="selectedGroups && actualGroups" class="check">
                        <img
                          v-if="
                            selectedGroups.filter((e) => e.deviceGroupId === group.deviceGroupId).length > 0 ||
                            actualGroups.filter((g) => g.deviceGroupId === group.deviceGroupId).length > 0
                          "
                          class=""
                          src="@/assets/icons/check.svg"
                        />
                      </div>
                      <span class="font-weight-light">{{ group.deviceGroupName }}</span>
                    </div>
                  </div>
                  <div
                    v-if="!loadedGroups.length"
                    class="custom-control__select__option d-flex align-items-center gray-text"
                  >
                    {{ $t("SELECT_NO_DATA") }}
                  </div>
                </div>
              </div>
              <div v-else>
                <a v-if="selectedGroups.length < loadedGroups.length" class="" @click="selectGroupVisible = true">
                  {{ $t("pridatKDalsiSKupine") }}
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      :class="{
        opened: opened.indexOf('newGroup') >= 0,
        'last-active': opened.indexOf('newGroup') == opened.length - 1
      }"
      class="side-box__inner"
    >
      <div class="side-box__header d-flex justify-content-between align-items-center">
        <div class="atom-back atom-back--gray" @click="toggleGroupConfirmation()">
          <div class="atom-back__inner d-flex align-items-center">
            <img src="@/assets/icons/arrows/arr-gray-left.svg" />
            <span>{{ $t("zpet") }}</span>
          </div>
        </div>
        <button class="btn btn-primary" @click="createGroup()">
          <div class="atom-icon">
            <img src="@/assets/icons/actions/ico-btn-ulozit.svg" />
          </div>
          {{ $t("vytvoritRoutovaciSkupinu") }}
        </button>
      </div>
      <div class="side-box__title">
        <h2>{{ $t("novaRoutovaciSkupina") }}</h2>
      </div>
      <div class="side-box__content">
        <div v-if="errors.group" class="text-danger">
          {{ errors.group }}
        </div>
        <div class="side-box__row d-flex align-items-center mt-3">
          <span class="side-box__content__label">{{ $t("nazevSkupiny") }}</span>
          <div
            :class="{ 'has-error': errors.group && !newGroup.deviceGroupName }"
            class="side-box__content__input custom-control__custom-input ml-3"
          >
            <span v-if="!newGroup.deviceGroupName" class="placeholder">{{ $t("zadejteNazevRotovaciSkupiny") }}</span>
            <input
              v-model="newGroup.deviceGroupName"
              autofocus
              class="w-100"
              maxlength="30"
              minlength="1"
              placeholder=""
              type="text"
              @click="changedEvent"
            />
          </div>
        </div>
        <div class="side-box__row d-flex align-items-center mt-3">
          <span class="side-box__content__label">{{ $t("popis") }}</span>
          <div class="side-box__content__input custom-control__custom-input ml-3">
            <span v-if="!newGroup.deviceGroupDesc" class="placeholder">{{ $t("volitelnyPopisRoutovaciSkupiny") }}</span>
            <input
              v-model="newGroup.deviceGroupDesc"
              autofocus
              class="w-100"
              maxlength="255"
              placeholder=""
              type="text"
              @click="changedEvent"
            />
          </div>
        </div>
      </div>
    </div>
    <SaveConfirmationModal
      :opened="openedEndpointConfirmation"
      :text="'chceteUlozitProvedeneZmeny'"
      @close="toggleEndpointConfirmation"
      @no="
        () => {
          $emit('reloadItems', originalEndpoint)
          closeBox('editEndpoint')
        }
      "
      @yes="runEdit()"
    />
    <SaveConfirmationModal
      :opened="openedGroupConfirmation"
      :text="'chceteUlozitProvedeneZmeny'"
      @close="toggleGroupConfirmation"
      @no="
        () => {
          clearGroup()
          closeBox('newGroup')
        }
      "
      @yes="createGroup()"
    />
    <div v-if="errorsToTranslate.length > 0">
      <ErrorModal
        :centered="true"
        :errors="errorsToTranslate"
        :opened="openedError"
        @close="
          () => {
            openedError = false
            $emit('closeBox', 'editEndpoint')
          }
        "
      />
    </div>
    <div v-if="errorsToTranslate1.length > 0">
      <ErrorModal :centered="true" :errors="errorsToTranslate1" :opened="openedError1" @close="openedError1 = false" />
    </div>
  </div>
</template>

<script>
import _ from "lodash"
import axios from "axios"
import SaveConfirmationModal from "@/components/confirmations/save.vue"
import ErrorModal from "@/components/confirmations/translatedErrors.vue"
import TransformFunctionField from "@/components/inputs/specific/TransformFunctionField.vue"
import NewEndpointFormFields from "@/components/modals/endpoints/NewEndpointFormFields.vue"
import EndpointHeadersField from "@/components/modals/endpoints/EndpointHeadersField.vue"
import FormInput from "@/components/forms/FormInput.vue"
import { useProjectStore } from "@/store/modules/project"

export default {
  components: {
    FormInput,
    NewEndpointFormFields,
    EndpointHeadersField,
    TransformFunctionField,
    SaveConfirmationModal,
    ErrorModal
  },
  props: {
    opened: Array,
    originalEndpoint: Object,
    protocol: {
      type: String,
      required: true
    },
    showDataFlows: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  setup() {
    const projectStore = useProjectStore()

    return { projectStore }
  },
  data() {
    return {
      changed: false,
      endpoint: {},
      actualGroups: [],
      protocolOpened: false,
      loadedGroups: [],
      selectedGroups: [],
      groupsToUnappend: [],
      groupsOpened: false,
      parametersTagsOpened: false,
      parametersOpened: false,
      selectedParameters: [],
      tagsOpened: false,
      selectedEndpointTags: [],
      selectedGroupTags: [],
      groupTags: [],
      writtenEndpointTags: "",
      writtenGroupTags: "",
      newGroup: {
        projectId: "",
        deviceGroupName: "",
        deviceGroupDesc: ""
      },
      openedEndpointConfirmation: false,
      openedGroupConfirmation: false,
      errors: {
        endpoint: "",
        group: ""
      },
      selectGroupVisible: false,
      groupsAddComplete: false,
      groupsRemoveComplete: false,
      errorsToTranslate: [],
      openedError: false,
      openedError1: false,
      errorsToTranslate1: [],
      isSubtopicValid: true
    }
  },
  computed: {
    project() {
      return this.projectStore.selectedProject
    },
    subtopic() {
      if (this.endpoint.protocol !== "MQTT") {
        return ""
      }

      return this.endpoint.custDestParameters.address.split(".").pop() || ""
    }
  },
  watch: {
    originalEndpoint() {
      this.endpoint = Object.assign({}, this.originalEndpoint)
      this.actualGroups = [...(this.originalEndpoint.deviceGroups || [])]
    },
    project() {
      this.endpoint = Object.assign({}, this.originalEndpoint)
      this.loadGroups()
      this.setProject()
      this.actualGroups = [...(this.originalEndpoint.deviceGroups || [])]
    },
    writtenEndpointTags() {
      this.createTagsArray()
    }
  },
  async mounted() {
    if (!this.project || !this.originalEndpoint) {
      return
    }

    this.endpoint = Object.assign({}, this.originalEndpoint)
    this.loadGroups()
    this.setProject()
    this.actualGroups = [...(this.originalEndpoint.deviceGroups || [])]
  },
  methods: {
    changedEvent() {
      this.changed = true
    },
    openBox(box) {
      this.$emit("openBox", box)
    },
    closeBox(box) {
      if (box == undefined) {
        this.resetValues()
        this.$emit("closeBox")
      } else {
        this.errors.group = ""
        this.$emit("closeBox", box)
      }
    },
    setProject() {
      this.endpoint.projectId = this.project.projectId
      this.newGroup.projectId = this.project.projectId
    },
    clearGroup() {
      this.newGroup = {
        projectId: "",
        deviceGroupName: "",
        deviceGroupDesc: ""
      }
      this.errors.group = ""
      this.setProject()
    },
    loadGroups() {
      axios
        .get(
          process.env.VUE_APP_API +
            "/device-groups?projectId[eq]=" +
            this.project.projectId +
            "&limit=1000&sort=%2BdeviceGroupName",
          {}
        )
        .then((result) => {
          this.loadedGroups = result.data.data
          this.getAllTags()
        })
        .catch(() => {})
    },
    resetValues() {
      this.errors.endpoint = ""
      this.groupsOpened = false
    },
    addRemoveGroup(group) {
      if (this.selectedGroups.indexOf(group) == -1) {
        this.selectedGroups.push(group)
      } else {
        this.selectedGroups.splice(this.selectedGroups.indexOf(group), 1)
      }
    },
    unappendGroup(group) {
      this.groupsToUnappend.push(group)
      this.actualGroups.splice(this.actualGroups.indexOf(group), 1)
    },
    addRemoveParameter(parameter) {
      if (this.selectedParameters.indexOf(parameter) == -1) {
        this.selectedParameters.push(parameter)
      } else {
        this.selectedParameters.splice(this.selectedParameters.indexOf(parameter), 1)
      }
    },
    addRemoveTag(tag) {
      if (this.writtenEndpointTags.indexOf(tag) == -1) {
        this.writtenEndpointTags += tag
      }
    },
    createTagsArray() {
      let written = this.writtenEndpointTags.split(",")
      let selected = []
      written.forEach((tag) => {
        let trimmed = tag.trim()
        selected.push(trimmed)
      })
      this.selectedEndpointTags = selected
    },
    async runEdit() {
      this.errorsToTranslate = []
      let editEndpoint = await this.editEndpoint()
      if (editEndpoint) {
        let editGroups = await this.editGroups()
        if (editGroups) {
          if (this.errorsToTranslate.length > 0) {
            this.openedError = true
          } else {
            this.$emit("closeBox", "editEndpoint")
          }
          this.$emit("reloadItems", this.endpoint)
          this.resetValues()
          this.selectedGroups = []
          this.groupsToUnappend = []
        }
      }
    },
    async editEndpoint() {
      if (
        this.endpoint.custDestName &&
        (this.endpoint.custDestParameters.url || this.endpoint.custDestParameters.address)
      ) {
        const url = `${process.env.VUE_APP_API}${this.protocol === "HTTP" ? "/http/endpoints" : "/mqtt/gateways"}/${
          this.endpoint.custDestId
        }`
        try {
          await axios.put(url, this.endpoint)
        } catch (error) {
          this.errorsToTranslate.push(error.data)
        }
        return true
      } else {
        this.errors.endpoint = this.$t("fillAllFieldsError")
      }
    },
    async editGroups() {
      let append = await this.appendGroups()
      let unappend = await this.unappendGroups()

      if (append || unappend) {
        this.$emit("actualizationGroupList")
      }
      return true
    },
    async appendGroups() {
      let endpointId = this.endpoint.custDestId

      let counterPost = 0
      let edited = this.endpoint
      for (const group of this.selectedGroups) {
        this.actualGroups.push(group)
        try {
          await axios.post(
            process.env.VUE_APP_API + "/device-groups/" + group.deviceGroupId + "/endpoints/" + endpointId + "/assign",
            {},
            {}
          )
          counterPost++
          if (edited.deviceGroups.findIndex((x) => x.deviceGroupId == group.deviceGroupId) == -1) {
            edited.deviceGroups.push(group)
          }

          if (counterPost == this.selectedGroups.length) {
            this.selectedGroups = []
          }
        } catch (error) {
          this.errorsToTranslate.push(error.data)
          counterPost++
          if (counterPost == this.selectedGroups.length) {
            this.selectedGroups = []
          }
        }
      }
      return !!counterPost
    },
    async unappendGroups() {
      let endpointId = this.endpoint.custDestId

      let counterPost = 0
      let edited = this.endpoint
      for (const unappendGroup of this.groupsToUnappend) {
        try {
          await axios.delete(
            process.env.VUE_APP_API +
              "/device-groups/" +
              unappendGroup.deviceGroupId +
              "/endpoints/" +
              endpointId +
              "/assign",
            {}
          )
          counterPost++
          edited.deviceGroups.splice(edited.deviceGroups.indexOf(unappendGroup), 1)
          if (counterPost == this.unappendGroups.length) {
            this.groupsToUnappend = []
          }
        } catch (error) {
          this.errorsToTranslate.push(error.data)
          counterPost++
          if (counterPost == this.unappendGroups.length) {
            this.groupsToUnappend = []
          }
        }
      }
      return !!counterPost
    },
    createGroup() {
      this.errorsToTranslate1 = []
      if (this.newGroup.deviceGroupName) {
        axios
          .post(process.env.VUE_APP_API + "/device-groups", this.newGroup, {})
          .then((result) => {
            let groupId = result.data.deviceGroupId

            let createdGroup = Object.assign(this.newGroup)
            createdGroup.deviceGroupId = groupId
            this.clearGroup()
            this.loadedGroups.push(createdGroup)
            this.selectedGroups.push(createdGroup)
            this.$emit("closeBox", "newGroup")
          })
          .catch((error) => {
            this.errorsToTranslate1.push(error.data)
            this.openedError1 = true
          })
      } else {
        this.errors.group = this.$t("fillAllFieldsError")
      }
    },
    getAllTags() {
      this.groupTags = _(this.loadedGroups)
        .flatMap((f) => f.tags)
        .sortedUniq()
        .value()
    },
    handleTransformChanged(transform) {
      this.endpoint.transformationId = transform.transformationId
    },
    toggleEndpointConfirmation() {
      if (this.changed) {
        this.openedEndpointConfirmation = !this.openedEndpointConfirmation
      } else {
        this.openedEndpointConfirmation = false
        this.$emit("closeBox", "editEndpoint")
      }
    },
    toggleGroupConfirmation() {
      this.openedGroupConfirmation = !this.openedGroupConfirmation
    },
    changeSubtopic(event) {
      let split = this.endpoint.custDestParameters.address.split(".")
      this.endpoint.custDestParameters.address = split.slice(0, split.length - 1).join(".") + "." + event.target.value
    }
  }
}
</script>

<style lang="scss" scoped></style>
